import { useEffect, useState } from 'react';

export const projectFonts: string[] = []; // Здесь массив онлайн стилей, используемых в приложении

const loadFont = (url: string) => {
  return new Promise((resolve) => {
    const request = new XMLHttpRequest();
    request.open('get', url, true);
    request.responseType = 'arraybuffer';
    request.onload = function () {
      if (request.response) {
        return resolve(true);
      } else {
        console.info('Font could not be loaded: ' + request.statusText);
        return resolve(false);
      }
    };

    request.onerror = function () {
      console.info('Font could not be loaded');
      resolve(false);
    };

    request.send();
  });
};

export const useAwaitFonts = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    Promise.all(projectFonts.map(loadFont)).then(() => setLoaded(true));
  }, []);

  return loaded;
};
